/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import DictionaryContainerHeader from '@/views/pages/Dictionary/elements/DictionaryContainerHeader';
import DictionaryItem from '@/views/pages/Dictionary/elements/DictionaryItem';
import Spinner from '@/views/components/Spinner/Spinner';

import styles from '@/views/pages/Dictionary/Dictionary.module.scss';

const DictionaryContainer = ({ 
	dictData, 
	isLoading, 
	onEditItem,
	onDeleteItem,
	noRecords,
}) => {
	
	const { dict } = useSelector((state) => state.app);

	return (
		<section className={ styles['dictionary__container'] }>
			<DictionaryContainerHeader />
			{ !noRecords && dictData && !isLoading && dictData.map((item) => {
				return (
					<DictionaryItem
						key={ item.id }
						data={ item }
						onEditItem={ onEditItem }
						onDeleteItem={ onDeleteItem }
					/>
				);

			})}
			{ (!dictData || isLoading) && (
				<Spinner addClass='table__spinner' />
			)}
			{ noRecords && (
				<div className='table__no-elements'>
					{ dict.dictionary.list.noElementsAded}
				</div>
			)}
			{ !noRecords && dictData && dictData.length === 0 && (
				<div className='table__no-elements'>
					{ dict.dictionary.list.noElements}
				</div>
			)}
		</section>
	);
};
export default DictionaryContainer;